var map = {
	"./btn_add.svg": 230,
	"./btn_add_patient.svg": 315,
	"./btn_back.svg": 173,
	"./btn_delete_patient.svg": 316,
	"./btn_delete_patient_done.svg": 317,
	"./btn_more.svg": 231,
	"./icon_add_patient_checkbox.svg": 318,
	"./icon_add_patient_checkbox_select.svg": 319,
	"./icon_calendar.svg": 174,
	"./icon_calendar_disable.svg": 320,
	"./icon_camera.svg": 321,
	"./icon_close.svg": 322,
	"./icon_conforms.svg": 323,
	"./icon_delete_patient.svg": 324,
	"./icon_delete_patient_select.svg": 325,
	"./icon_delete_time.svg": 326,
	"./icon_delete_time_select.svg": 327,
	"./icon_edit.svg": 328,
	"./icon_edit_disable.svg": 329,
	"./icon_group_checkbox.svg": 330,
	"./icon_group_checkbox_select.svg": 150,
	"./icon_inconformity.svg": 331,
	"./icon_mind.svg": 332,
	"./icon_more.svg": 168,
	"./icon_more2.svg": 95,
	"./icon_qr_code.svg": 333,
	"./icon_radio.svg": 334,
	"./icon_radio_select.svg": 335,
	"./icon_time.svg": 336,
	"./icon_tips.svg": 337,
	"./icon_type_select.svg": 338,
	"./img_add_news_patient.svg": 339,
	"./img_female.svg": 232,
	"./img_follow_up.svg": 340,
	"./img_follow_up_null.svg": 341,
	"./img_group_null.svg": 342,
	"./img_male.svg": 233,
	"./img_network_null.svg": 343,
	"./img_notice_null.svg": 344,
	"./img_patient_accept.svg": 345,
	"./img_patient_finish.svg": 346,
	"./img_patient_no-action.svg": 347,
	"./img_patient_null.svg": 234,
	"./img_patient_refuse.svg": 348,
	"./img_personal.svg": 235,
	"./img_personal_bg.svg": 236,
	"./img_questionnaire.svg": 349,
	"./img_questionnaire_null.svg": 350,
	"./img_return_visit.svg": 351,
	"./img_search_null.svg": 237,
	"./img_time_null.svg": 352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 792;